import { EmbeddedMod } from "@src/store/slices/experienceBuilder/types";
import { ImageListItem } from "@src/features/experienceBuilder/modifications/basicMods/ImageListItem";
import { InjectionListItem } from "@src/features/experienceBuilder/modifications/basicMods/InjectionListItem";
import { TextListItem } from "@src/features/experienceBuilder/modifications/basicMods/TextListItem";
import { LayoutListItem } from "@src/features/experienceBuilder/modifications/basicMods/LayoutListItem";
import { BannerComponentListItem } from "@src/features/experienceBuilder/modifications/components/BannerComponentListItem";
import { BundleOnsiteUpsellComponentListItem } from "@src/features/experienceBuilder/modifications/components/BundleOnsiteUpsellComponentListItem";
import { GenericComponentListItem } from "@src/features/experienceBuilder/modifications/components/GenericComponentListItem";
import { ImageComponentListItem } from "@src/features/experienceBuilder/modifications/components/ImageComponentListItem";
import { OnsiteUpsellComponentListItem } from "@src/features/experienceBuilder/modifications/components/OnsiteUpsellComponentListItem";
import { TextComponentListItem } from "@src/features/experienceBuilder/modifications/components/TextComponentListItem";

interface ModificationListItemFactoryProps {
  mod: EmbeddedMod;
}

export const ModificationListItemFactory = ({
  mod,
}: ModificationListItemFactoryProps) => {
  switch (mod.type) {
    case "text":
      return <TextListItem mod={mod} />;
    case "image":
      return <ImageListItem mod={mod} />;
    case "layout":
      return <LayoutListItem mod={mod} />;
    case "injection":
      return <InjectionListItem mod={mod} />;
    case "textComponent":
      return <TextComponentListItem mod={mod} />;
    case "imageComponent":
      return <ImageComponentListItem mod={mod} />;
    case "bannerComponent":
      return <BannerComponentListItem mod={mod} />;
    case "genericComponent":
      return <GenericComponentListItem mod={mod} />;
    case "onsiteUpsell":
      return <OnsiteUpsellComponentListItem mod={mod} />;
    case "bundleOnsiteUpsell":
      return <BundleOnsiteUpsellComponentListItem mod={mod} />;
  }
};
